<template>
    <div v-loading="loading" class="alarmClass">
      <div>
        <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="设备名称" prop="name">
                <el-input
                clearable
                disabled v-model="form.name"
             
                maxlength="20"
                ></el-input> 
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="在线状态" prop="onlineStatus">
              
              <el-input
                clearable
                disabled v-model="form.onlineStatusValue"
             
                maxlength="100"
              ></el-input> 
             
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="当前电量" prop="currentPower">
              
              <el-input
                clearable
                disabled v-model="form.currentPower"
             
                maxlength="100"
              ></el-input> 
             
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="绑定老人" prop="elderlyName">
              
              <el-input
                clearable
                disabled v-model="form.elderlyName"
              
                maxlength="100"
              ></el-input> 
             
            </el-form-item>
          </el-col>
        </el-row>
        </el-form>
        <el-tabs v-model="activeName" @tab-click="handleClick" :before-leave="tabsBefore">
          <el-tab-pane label="参数配置" name="first" lazy>
            <braceletConfig :row="row" @rebackData="getInfo"></braceletConfig>
          </el-tab-pane>
          <el-tab-pane label="定位数据" name="second" lazy>
            <braceletLocation :row="row"></braceletLocation>
           </el-tab-pane>
          <el-tab-pane label="健康数据" name="third" lazy>
            <healthData :row="row"></healthData>
          </el-tab-pane>
          
      
          <el-tab-pane
            label="异常记录"
            name="five"
          >
          <abnormalRecord :row="row"></abnormalRecord>
          </el-tab-pane>
  
         
        </el-tabs>
        
      </div>
    </div>
  </template>
  <script>
  import { getProjectList } from '@/api/crmedical/project/project';
  import { getDictionary } from '@/api/common.js';
  import braceletConfig from './components/braceletConfig.vue';
  import braceletLocation from './components/braceletLocation.vue';
  import healthData from './components/healthData.vue';
  import abnormalRecord from './components/abnormalRecord.vue';
  import { removeStore, getStore } from '@/util/store';
  import { setStore } from '@/util/store';
  import {
    getSmartDeviceDetail
  } from  '@/api/nursingHome/elderDevice';
  export default {
    components: {braceletConfig,braceletLocation,abnormalRecord,healthData},
    props: {
      row: {
        default: {},
      },
      nursinghomeId: {},
      nursinghomeName: {},
      model: {
        default: 'add',
      },
    },
    data() {
      return {
        activeFlag: true,
        projectList: [],
        activeName: 'first',
        form: {
          onlineStatusValue: '',
          name: '',
          // birthday: '123',
          elderlyName: '',
          currentPower:''
        },
        formRules: {
        
        },
        matetialList: [],
      };
    },
    created() {
      this.initData();
    },
    mounted() {},
    watch: {},
    methods: {
      
      initData() {
        this.form.name = this.row.name
        this.form.onlineStatusValue = this.row.onlineStatusValue
        this.form.elderlyName = this.row.elderlyName
        getSmartDeviceDetail({id:this.row.id}).then((res)=>{
          this.form.currentPower= res.data.currentPower
        })
      },
      getInfo(){

      },
      handleClick() {
        if (this.activeName === 'first') {
          this.$refs.baseInfoRef.initData();
        }
        if (this.activeName === 'second') {
          this.$refs.FamilyInfoRef.initData();
        }
        if (this.activeName === 'third') {
          this.$refs.HealthInfoRef.initData();
          // this.activeName = 'fourth'
        }
        if (this.activeName === 'fourth') {
          this.$refs.MedicalTestInfoRef.initData();
          // this.activeName = 'five'
        }
        if (this.activeName === 'five') {
          this.$refs.CateringBedsInfoRef.initData();
        }
        console.log(this.activeName);
      },
     
    },
  };
  </script>
  <style scoped>
  .alarmClass {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  ::v-deep .el-col-8 {
    height: 54px;
  }
  </style>
  